import config from "../config";
import browserHistory from "../helpers/browserHistory";
import HttpClient from "../helpers/httpclient";

const path = "banners";

export async function fetch(id) {
  const response = await HttpClient.get(`${config.api}/${path}/${id}`);
  return response.data;
}

export async function list(page = 1, status = "all", pageName = null, term = null, sort = null, filter = null) {
  let sanitizedPageName = pageName;
  if (sanitizedPageName !== null && sanitizedPageName !== undefined) {
    const trimmed = String(sanitizedPageName).replace(/^\/+/, "");
    sanitizedPageName = trimmed.split("/")[0] || null;
    if (sanitizedPageName === "") {
      sanitizedPageName = null;
    }
  }
  const params = {
    params: { page, status, filter, pageName: sanitizedPageName },
  };
  if (term) {
    params.params.q = term;
  }
  if (sort) {
    params.params.order = sort.order;
    params.params.direction = sort.direction;
  }
  const response = await HttpClient.get(`${config.api}/${path}`, params);
  return response.data;
}

export async function listExternal() {
  const response = await HttpClient.get(`${config.api}/${path}/external`);
  return response.data;
}

// Banners displayed in the application shell. `list` backs the administrative
// management screen and requires the `banners.list` permission, so the shell
// must not use it to render banners for ordinary signed-in users.
export async function listActive(pageName = null) {
  let sanitizedPageName = pageName;
  if (sanitizedPageName !== null && sanitizedPageName !== undefined) {
    const trimmed = String(sanitizedPageName).replace(/^\/+/, "");
    sanitizedPageName = trimmed.split("/")[0] || null;
  }
  const response = await HttpClient.get(`${config.api}/${path}/active`, {
    params: { pageName: sanitizedPageName },
  });
  return response.data;
}

export async function save(object, redirect = true) {
  const method = object.id ? "put" : "post";
  const url = `${config.api}/${path}/${object.id || ""}`;
  const response = await HttpClient[method](url, object);
  if (redirect) {
    browserHistory.push(`/${path}`);
  }
  return response;
}

export async function sync() {
  const response = await HttpClient.get(`${config.api}/${path}/sync`);
  return response.data;
}

export function utcConverter(toLocalTime, time = null) {
  if (!time) {
    return null;
  }
  const today = new Date();
  const offset = (today.getTimezoneOffset() / 60) * (toLocalTime ? -1 : 1);
  let hours = parseInt(time.split(":")[0], 10);
  hours = hours + offset;
  if (hours >= 24) {
    hours = hours - 24;
  }
  if (hours < 0) {
    hours = hours + 24;
  }
  if (hours < 10) {
    hours = `0${hours}`;
  }
  return `${hours}:${time.split(":")[1]}`;
}
